module.exports = __webpack_public_path__ + "img/Tag.803785cb.svg";